// @flow

import React, {Component} from 'react';
import {connector} from '../store';
import {Link} from 'react-router-dom';
import PassportLabel from './PassportLabel.jsx';
import CoveImage from './CoveImage.jsx';
import {getPlayingVideoById, videoDataToPlayerData} from '../helpers';

import PassportUser from '../../User/PassportUser';

let user = PassportUser();

export class WatchablePreview extends Component<*, *> {
  render() {
    let classes = 'video-item-watchable',
        isPlaying = !this.props.player.livestreamOverride && getPlayingVideoById(this.props.player.container, this.props.video.id) !== null;

    if (this.props.video.minimumPassportLevel > 0) {
      classes += ' passport';
    }

    if (this.props.video.isWatchable) {
      classes += ' is-playable';
    }

    let relatedClass = 'related-item-title video-item-title';

    if (this.props.displayShowTitle) {
      relatedClass += ' headline-section';
    }

    let path = `/${this.props.show.slug}/video/${this.props.video.slug}/`;
    let replace = path === window.location.pathname;

    return (
      <Link className="no-delay" to={path} replace={replace} onClick={() => {
        this.props.onClick && this.props.onClick();
        this.props.loadPlayerData(videoDataToPlayerData(this.props.video, true));
      }}>
        <div className={classes}>
          <div className="related-item-preview video-item-preview" style={{marginBottom: 0}}>
            {!isPlaying && <PassportLabel isVideo={true} video={this.props.video} userSignedIn={user.isSignedIn()}/>}

            <CoveImage
              alt={this.props.video.title}
              aspectRatio={0.5625}
              class="related-item-thumbnail video-item-thumbnail"
              imageSizes={{min: 100, max: 400, step: 100}}
              sizes={[{breakpoint: '1201px', width: '400px'}, {breakpoint: '769px', width: '33vw'},
                {breakpoint: '641px', width: '50vw'}, {breakpoint: '0', width: '100vw'}]}
              url={this.props.video.mezzanine}/>

            {this.props.video.displaySeason && this.props.video.season && this.props.video.episodeWithinSeason &&
              <div className="video-item-preview-season-indicator body-small">
                <b>S</b>{this.props.video.season} <b>E</b>{this.props.video.episodeWithinSeason}
              </div>
            }

            {!this.props.video.hidePlayButton && !isPlaying &&
              <div className="play-button-width-wrapper">
                <div className="play-button-height-wrapper">
                  <div className="play-button">
                    <div className="play-arrow"/>
                  </div>
                </div>
              </div>
            }

            {isPlaying &&
              <div className="video-item-playing-overlay headline-section">
                Now Playing
              </div>
            }
          </div>
          <div>
            <div className={relatedClass}>
              {this.props.showTitle &&
                <div className="headline-section video-item-show-title">
                  {this.props.showTitle}
                </div>
              }

              {!this.props.video.hideTitle &&
                <span className={'video-item-episode-title' + (this.props.showTitle ? '' : ' headline-section')}>
                  {this.props.video.title}
                </span>
              }
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default connector(WatchablePreview);